<template>
  <formatted-date
    :value="props.value"
    :format="format"
  />
</template>

<script>
import FormattedDate from 'src/modules/admin/components/FormattedDate'
import TableCellMixin from 'src/modules/admin/components/model-table/components/TableCellMixin'

export default {
  name: 'DateTimeCell',
  components: {
    FormattedDate
  },
  mixins: [TableCellMixin],
  props: {
    props: {
      type: Object,
      required: true
    },
    format: {
      type: String,
      required: false,
      default: 'timestamp'
    }
  }
}
</script>
